import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import KpiReportContainer from '../../containers/targetmng/KpiReportContainer';

const KpiReportPage = () => {
  return (
    <div>
      <BreadcrumbsContainer title="목표 관리/KPI 리포트" icon="chart" />
      <KpiReportContainer />
    </div>
  );
};

export default KpiReportPage;
